"use client";

import { c as _c } from "react/compiler-runtime";
import { getSelectedOrgId } from "@/lib/authenticatedFetch";
import VariableInput from "./VariableInput";
import type { Edge, Node } from "@xyflow/react";
interface NodeDefinition {
  type: string;
  resultSchema?: {
    properties?: Record<string, {
      description?: string;
      type?: string;
    }>;
  };
}
interface EmailFromInputProps {
  label: string;
  description: string;
  headerRight?: React.ReactNode;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  connectorId?: string;
  currentNodeId?: string;
  allNodes?: Node[];
  allEdges?: Edge[];
  nodeDefinitions?: NodeDefinition[];
}
export default function EmailFromInput(t0) {
  const $ = _c(20);
  const {
    label,
    description,
    headerRight,
    value,
    onChange,
    placeholder,
    connectorId,
    currentNodeId,
    allNodes,
    allEdges,
    nodeDefinitions
  } = t0;
  const orgId = getSelectedOrgId();
  const hasCustomConnector = !!connectorId;
  if (!hasCustomConnector) {
    const defaultAddress = orgId ? `B3OS <b3os_${orgId}@b3os.org>` : "Org-specific default address";
    let t1;
    if ($[0] !== headerRight || $[1] !== label) {
      t1 = label && <div className="flex items-center justify-between gap-3"><label className="field-label block">{label}</label>{headerRight}</div>;
      $[0] = headerRight;
      $[1] = label;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="border-ds-border-default text-ds-text-muted dark:bg-ds-neutral-800/50 w-full rounded-lg border bg-zinc-50 px-3 py-2 text-sm">{defaultAddress}</div>;
      t3 = <p className="label-xs">Connect your own Resend connector to use a custom sender address</p>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t2 = $[3];
      t3 = $[4];
    }
    let t4;
    if ($[5] !== t1) {
      t4 = <div className="space-y-2">{t1}{t2}{t3}</div>;
      $[5] = t1;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  const t1 = placeholder ?? "You <you@yourdomain.com>";
  let t2;
  if ($[7] !== allEdges || $[8] !== allNodes || $[9] !== currentNodeId || $[10] !== description || $[11] !== label || $[12] !== nodeDefinitions || $[13] !== onChange || $[14] !== t1 || $[15] !== value) {
    t2 = <VariableInput label={label} description={description} value={value} onChange={onChange} placeholder={t1} currentNodeId={currentNodeId} allNodes={allNodes} allEdges={allEdges} nodeDefinitions={nodeDefinitions} />;
    $[7] = allEdges;
    $[8] = allNodes;
    $[9] = currentNodeId;
    $[10] = description;
    $[11] = label;
    $[12] = nodeDefinitions;
    $[13] = onChange;
    $[14] = t1;
    $[15] = value;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  let t3;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="text-ds-text-secondary text-xs font-medium">Set this to an address on your verified Resend domain</p>;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== t2) {
    t4 = <div className="space-y-2">{t2}{t3}</div>;
    $[18] = t2;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}